import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'

const getTitleStart = ({ allestimento_breve, marca, modello }) =>
  marca === modello ? [marca, allestimento_breve] : [marca, modello]

function Metadata({ isNlt, product }) {
  return (
    <Helmet>
      <title>
        {product.id_auto === null
          ? ''
          : `${getTitleStart(product).join(' ')} ${product.anno} auto ${
              isNlt ? 'noleggia' : 'acquista'
            } | ${product.id_auto} | brumbrum`}
      </title>
    </Helmet>
  )
}

Metadata.defaultProps = {
  isNlt: false,
}

const mapStateToProps = state => ({
  product: state.product,
})

export default connect(mapStateToProps, null)(Metadata)
